import type { PageContextServer } from 'vike/types';

/**
 * Sets the HTML lang attribute on the <html> tag for every page.
 *
 * pageContext.locale is set by onBeforeRoute based on the URL prefix
 * (en/fi/sv). This runs at render time for both SSR and pre-rendered
 * static pages, so Google always sees the correct lang in the HTML.
 */
export default (pageContext: PageContextServer): string => {
  const locale = (pageContext as unknown as { locale?: string }).locale;
  if (locale === 'fi' || locale === 'sv') return locale;
  return 'en';
};
